import Reveal from "@/components/Reveal";
import CtaGroup from "@/components/CtaGroup";

/**
 * Strong closing call-to-action band (blush/gold/black).
 */
export default function CtaSection({
  title = "Let's Take Care of Your Property.",
  text = "Tell us what you need and we'll get back to you about your free estimate.",
  estimateLabel = "Get a Free Estimate",
}) {
  return (
    <section className="relative bg-ink text-white overflow-hidden" data-testid="cta-section">
      <div
        className="absolute inset-0"
        aria-hidden="true"
        style={{
          background:
            "radial-gradient(55% 120% at 100% 0%, rgba(244,204,215,0.14), transparent 55%), radial-gradient(50% 120% at 0% 100%, rgba(217,185,110,0.16), transparent 55%)",
        }}
      />
      <div className="container-x relative py-20 sm:py-28">
        <div className="max-w-3xl">
          <Reveal>
            <span className="eyebrow text-blush">Free Estimates</span>
            <h2 className="mt-4 text-4xl sm:text-5xl lg:text-[3.75rem] text-white">
              {title}
            </h2>
            <p className="mt-6 text-lg text-white/75 max-w-xl leading-relaxed">{text}</p>
          </Reveal>
          <Reveal delay={0.12} className="mt-9">
            <CtaGroup dark estimateLabel={estimateLabel} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
